import FlashLib from "flashlib";

export default class BasePaytableScrollBarContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.interactive = true;
        this._value = 0;
        this._dragable = false;

        this.init();
        this.addListeners();

        this.value = 0;
    }

    init() {
        this.background = this.getChildAt(0);
        this.background.interactive = true;

        this.bar = this.getChildAt(1);
        this.bar.buttonMode = true;
        this.bar.interactive = true;

        this.drawBackground(820);

        this.bar.clear();
        this.bar.beginFill(0xFFFFFF);
        this.bar.drawRoundedRect(-(14 / 2), -(60 / 2), 14, 60, 7);
        this.bar.endFill();

        this.hitArea = new PIXI.Rectangle(-this.background.width, 0, this.background.width * 3, this.background.height);
    }

    drawBackground(height) {
        height -= 30;
        this.background.clear();
        this.background.beginFill(0x5D5D5D);
        this.background.drawRoundedRect(-(14 / 2), -(height / 2), 14, height, 7);
        this.background.endFill();

        this.background.y = this.background.height / 2;
        this.hitArea = new PIXI.Rectangle(-this.background.width, 0, this.background.width * 3, this.background.height);
    }

    addListeners() {
        this.on('pointertap', this.onClick, this);
        this.on('pointermove', this.onMove, this);
        this.on('pointerdown', this.onBarDown, this);
        this.on('pointerup', this.onBarUp, this);
        this.on('pointerupoutside', this.onBarUp, this);
        this.on('pointercancel', this.onBarUp, this);
    }

    onBarDown(event) {
        this._dragable = true;
    }

    onBarUp(event) {
        this._dragable = false;
    }

    onMove(event) {
        if (this._dragable) {
            let point = event.data.getLocalPosition(this);
            this.updateValue(point);
        }
    }

    onClick(event) {
        let point = event.data.getLocalPosition(this);
        this.updateValue(point);
    }

    updateValue(point) {
        this.value = point.y / this.background.height * 100;
        this.emit('update', this.value);
    }

    setData(data) {
        this.drawBackground(data.containerHeight);

        let height = (data.containerHeight / data.contentHeight) * this.background.height;
        this.bar.clear();
        this.bar.beginFill(0xFFFFFF);
        this.bar.drawRoundedRect(-(14 / 2), -(height / 2), 14, height, 7);
        this.bar.endFill();
    }

    get value() {
        return this._value;
    }

    set value(value) {
        //console.log('scrollValue', value);
        if (value > 100) {
            value = 100;
        }
        if(value < 0) {
            value = 0;
        }
        this._value = value;
        this.bar.y = this.bar.height / 2 + ((this.background.height - this.bar.height) / 100 * this.value);
    }
}